import { jsxs, jsx } from 'react/jsx-runtime';
import { Alert } from '../../alert/alert.component.js';
import { Button } from '../../button/button.component.js';
import { FooterGroup, StyledFooter } from './modal-footer.style.js';

const ModalFooter = props => {
    const { disabled = false, error, footerProps, loading = false, onCancel, onSubmit, primaryBackgroundColor = 'primaryInverse', primaryText = 'Submit', secondaryText = 'Cancel', } = props;
    return (jsxs(FooterGroup, Object.assign({}, footerProps, { children: [error && jsx(Alert, Object.assign({ margin: { bottom: '16px' } }, { children: error }), void 0), jsxs(StyledFooter, { children: [jsx(Button, Object.assign({ mode: "primary", disabled: disabled, loading: loading, onClick: onSubmit }, { children: primaryText }), void 0), onCancel && (jsx(Button, Object.assign({ onClick: onCancel, margin: { left: '16px' } }, { children: secondaryText }), void 0))] }, void 0)] }), void 0));
};

export { ModalFooter };
